import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { Toaster } from "@/components/ui/sonner";
import EventOrganizerPage from "@/pages/EventOrganizerPage";

function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<EventOrganizerPage />} />
          </Routes>
        </BrowserRouter>
      </div>
      <Toaster position="top-right" richColors />
    </ThemeProvider>
  );
}

export default App;
